module.exports = __webpack_public_path__ + "static/media/kosher-icon.0a2ca58e.png";